module.exports = __webpack_public_path__ + "static/media/ajax-Loader.a43104b7.gif";